import { ArrowLeftIcon, PaletteIcon, ChatCircleDotsIcon, PlugsIcon, GearIcon } from '@phosphor-icons/react';
import { useRouter } from 'next/router';
import SidebarMenuItem from './SidebarMenuItem';
import { useFeatureFlags, type FeatureKey } from '@lib/hooks/useFeatureFlag';

type SettingsSidebarProps = {
  isExpanded: boolean;
  onBack: () => void;
}

const menuItems: { id: string; label: string; icon: typeof GearIcon; feature?: FeatureKey }[] = [
  { id: 'general', label: 'General', icon: GearIcon },
  { id: 'branding', label: 'Branding', icon: PaletteIcon },
  { id: 'chat', label: 'StreamAlive-powered chat', icon: ChatCircleDotsIcon },
  { id: 'integrations', label: 'Integrations', icon: PlugsIcon },
];

export default function SettingsSidebar({
  isExpanded,
  onBack
}: SettingsSidebarProps) {
  const router = useRouter();
  const currentPage = (router.query.page as string) || 'general';
  const { isEnabled } = useFeatureFlags();
  const visibleItems = menuItems.filter((item) => isEnabled(item.feature));

  const handlePageChange = (page: string) => {
    router.replace({
      pathname: router.pathname,
      query: { ...router.query, page }
    }, undefined, { shallow: true });
  };

  return (
    <div className={`${isExpanded ? 'px-6' : 'flex flex-col items-center'} mt-6 text-sm`}>
      <div className='flex flex-col gap-4'>
        <SidebarMenuItem
          label="Back"
          icon={<ArrowLeftIcon size={20} />}
          isExpanded={isExpanded}
          onClick={onBack}
        />

        {isExpanded && (
          <div className='px-2'>
            <p className='text-sm text-default-600'>Settings</p>
          </div>
        )}

        <div className='flex flex-col gap-1 -mt-2'>
          {visibleItems.map((item) => (
            <SidebarMenuItem
              key={item.id}
              label={item.label}
              icon={<item.icon size={20} />}
              isExpanded={isExpanded}
              isActive={currentPage === item.id}
              onClick={() => handlePageChange(item.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
